/**
 * Join name segments into a dot-separated path.
 *
 * When the first argument is `null`, returns an array of path segments instead.
 */
export function joinName(...parts: Array<string | string[] | null | undefined>): string | string[] {
  const asArray = parts[0] === null
  const raw = asArray ? parts.slice(1) : parts

  const segments = raw
    .flat(Infinity as 1)
    .filter((p): p is string => p != null && p !== '')
    .join('.')
    .split('.')
    .filter(Boolean)

  return asArray ? segments : segments.join('.')
}
